import graphql from 'babel-plugin-relay/macro';
import { useMutation } from 'react-relay';

import { DeleteJobCategoryMutation } from './__generated__/DeleteJobCategoryMutation.graphql';

const deleteJobCategoryMutation = graphql`
  mutation DeleteJobCategoryMutation($id: ID!) {
    deleteJobCategory(id: $id) {
      id @deleteRecord
    }
  }
`;

const useDeleteJobCategoryMutation = () =>
  useMutation<DeleteJobCategoryMutation>(deleteJobCategoryMutation);

export { useDeleteJobCategoryMutation };
